import axios from 'axios'
import Config from '../config.js'

const instance = axios.create({
	baseURL: Config.SERVER,
	withCredentials: false,
	timeout: 10000
});

export function addResponseHandler(success, error){
	instance.interceptors.response.use(success, error);
}

export default instance;